module.exports = __webpack_public_path__ + "static/media/phone.a9bf2176.svg";